import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useParams } from 'react-router-dom';

const TenantBackupManagement = () => {
  const { tenantId } = useParams();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Yedekleme Yönetimi - {tenantId}
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>AWS yedekleme yönetimi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default TenantBackupManagement;
